
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updateDraftDiscount,updateRecordsDiscount } from "@/api/inquiry";
import { DraftModel } from "../types";
import { deepClone } from "@/utils/deepClone";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: [] }) private selectedList: [];
  @Prop({ default: "" }) private inquirySheetId: "";
  @Prop({ default: "修改折扣" }) private title: "";
  private form = {
    saleDiscount: '',
    purchaseDiscount: '',
  };
  private newSelectedRows: DraftModel[] = [];

  @Watch("selectedList", { immediate: true })
  private async watchData() {
    this.newSelectedRows = deepClone(this.selectedList);
    // console.log(this.newSelectedRows)
  }
  private list = [
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      type: "input",
      placeholder: "请输入采购折扣",
      clearable: true,
      maxlength: 100,
      unit: "%",
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      type: "input",
      unit: "%",
      placeholder: "请输入销售折扣",
      clearable: true,
      maxlength: 100,
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    console.log('this.from',this.form)
    this.updateDraftDiscount(this.form);
    // (this.$refs.ruleForm as any).$refs.ruleForm.validate(
    //   async (valid: boolean) => {
    //     if (valid) {
    //       try {
    //         this.updateDraftDiscount(this.form);
    //       } catch (error) {
    //         console.error(error);
    //       }
    //     }
    //   }
    // );
  }
  private async updateDraftDiscount(form: any) {
    if (!this.newSelectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    const inquirySheetDetailIds = this.newSelectedRows.map(
      (item) => item.detailId
    );
    const ids = this.newSelectedRows.map((item) => item.draftId);
    const { purchaseDiscount, saleDiscount } = form;
    let params = {
      inquirySheetId: this.inquirySheetId,
      inquirySheetDetailIds,
      ids,
      purchaseDiscount: purchaseDiscount == ''?null:`${purchaseDiscount}%`,
      saleDiscount: saleDiscount == ''?null:`${saleDiscount}%`,
    };
    let paramsEdit = {
      ids: this.newSelectedRows.map((item) => item.detailInfoId),
      purchaseDiscount: purchaseDiscount == ''?null:`${purchaseDiscount}%`,
      saleDiscount: saleDiscount == ''?null:`${saleDiscount}%`,
    };
    try {
      this.isEdit
        ? await updateRecordsDiscount(paramsEdit)
        : await updateDraftDiscount(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch (e) {
      console.log(e)
    }
  }
}
